/* rev.52: menu mobile a pannelli (stile drill-down). Legge il menu gia' renderizzato dal tema, quindi ogni voce compare sempre. */
(function () {
  'use strict';
  var drawer = document.getElementById('NavDrawer');
  if (!drawer) return;

  var ICONS = {
    'promo':'tag','rossi':'glass','bianchi':'glass','bollicine':'flute','distillati':'tumbler','birre':'mug','idee-regalo':'gift',
    'cantine':'barrel','per-prezzo':'euro','rose':'rose','regioni':'map','abbinamenti':'cutlery','abbinamento':'cutlery'
  };
  var CHEV_R = '<svg class="sv-mm__chev" viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M7.5 4.5L13 10l-5.5 5.5"/></svg>';
  var CHEV_L = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12.5 4.5L7 10l5.5 5.5"/></svg>';
  var CLOSE = '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5.6 14.4L10 10l4.4 4.4M14.4 5.6L10 10 5.6 5.6"/></svg>';

  function handle(s) {
    return String(s).normalize('NFD').replace(/[^\x00-\x7f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function parse(ul) {
    var out = [];
    Array.prototype.forEach.call(ul.children, function (li) {
      if (li.tagName !== 'LI') return;
      var a = li.querySelector(':scope > a.mobile-nav__link') || li.querySelector(':scope > .mobile-nav__has-sublist > a.mobile-nav__link');
      if (!a) return;
      var sub = li.querySelector(':scope > ul.mobile-nav__sublist');
      out.push({ title: a.textContent.replace(/\s+/g, ' ').trim(), url: a.getAttribute('href') || '#', kids: sub ? parse(sub) : [] });
    });
    return out;
  }

  var uid = 0, panels = {}, stack = [], root, panelWrap;

  function icoSpan(title) {
    var h = handle(title);
    return '<span class="sv-mm__ico" data-sv-ico="' + (ICONS[h] || 'default') + '" data-sv-key="' + h + '" aria-hidden="true"></span>';
  }
  /* icona di default per ogni voce principale e per i gruppi con sottomenu; le voci semplici di secondo/terzo livello sono righe senza icona */
  function row(item, level) {
    var hasKids = item.kids.length > 0;
    var showIco = level === 1 || (level === 2 && hasKids);
    var ico = showIco ? icoSpan(item.title) : '';
    var cls = 'sv-mm__row' + (showIco ? '' : ' sv-mm__row--leaf');
    if (hasKids) {
      var id = 'sv-mm-p' + (++uid);
      makePanel(id, item, level);
      return '<li><button type="button" class="' + cls + '" data-sv-open="' + id + '">' + ico + '<span class="sv-mm__txt">' + esc(item.title) + '</span>' + CHEV_R + '</button></li>';
    }
    return '<li><a class="' + cls + '" href="' + esc(item.url) + '">' + ico + '<span class="sv-mm__txt">' + esc(item.title) + '</span></a></li>';
  }
  function makePanel(id, item, level) {
    var html = '<header class="sv-mm__head"><button type="button" class="sv-mm__back" data-sv-back>' + CHEV_L + '<span>Indietro</span></button>' +
      '<h2 class="sv-mm__title">' + esc(item.title) + '</h2>' +
      '<button type="button" class="sv-mm__close" data-sv-close aria-label="Chiudi menu">' + CLOSE + '</button></header><ul class="sv-mm__list">';
    if (level === 1) {
      html += '<li><a class="sv-mm__row sv-mm__row--all" href="' + esc(item.url) + '">' + icoSpan(item.title) + '<span class="sv-mm__txt">Vedi tutto: ' + esc(item.title) + '</span></a></li>';
    }
    item.kids.forEach(function (k) { html += row(k, level + 1); });
    html += '</ul>';
    var sec = document.createElement('section');
    sec.className = 'sv-mm__panel'; sec.id = id; sec.setAttribute('inert', ''); sec.setAttribute('aria-hidden', 'true');
    sec.setAttribute('aria-label', item.title);
    sec.innerHTML = html;
    panels[id] = sec;
  }

  function build() {
    var src = drawer.querySelector('ul.mobile-nav--main');
    if (!src) return;
    var old = drawer.querySelectorAll('.sv-mm, .sv-mm__panels');
    Array.prototype.forEach.call(old, function (n) { n.remove(); });
    uid = 0; panels = {}; stack = [];
    var items = parse(src);
    var html = '<ul class="sv-mm__list sv-mm__list--root">';
    items.forEach(function (it) { html += row(it, 1); });
    html += '</ul>';
    root = document.createElement('nav'); root.className = 'sv-mm'; root.setAttribute('aria-label', 'Menu principale'); root.innerHTML = html;
    src.insertAdjacentElement('afterend', root);
    panelWrap = document.createElement('div'); panelWrap.className = 'sv-mm__panels';
    Object.keys(panels).forEach(function (k) { panelWrap.appendChild(panels[k]); });
    drawer.appendChild(panelWrap);
    drawer.classList.add('sv-mm-ready');
  }

  function openPanel(id) {
    var p = panels[id]; if (!p) return;
    p.removeAttribute('inert'); p.setAttribute('aria-hidden', 'false'); p.style.zIndex = String(10 + stack.length); p.classList.add('is-open');
    stack.push(id);
    var b = p.querySelector('[data-sv-back]'); if (b) setTimeout(function () { b.focus({ preventScroll: true }); }, 30);
  }
  function back() {
    var id = stack.pop(); if (!id) return;
    var p = panels[id]; p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); p.setAttribute('inert', '');
    p.scrollTop = 0;
    var prev = stack.length ? panels[stack[stack.length - 1]] : root;
    var opener = (stack.length ? prev : root).querySelector('[data-sv-open="' + id + '"]');
    if (opener) opener.focus({ preventScroll: true });
  }
  function reset() { while (stack.length) back(); }

  drawer.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-sv-open],[data-sv-back],[data-sv-close]') : null;
    if (!t) return;
    if (t.hasAttribute('data-sv-open')) { e.preventDefault(); openPanel(t.getAttribute('data-sv-open')); }
    else if (t.hasAttribute('data-sv-back')) { e.preventDefault(); back(); }
    else if (t.hasAttribute('data-sv-close')) {
      e.preventDefault();
      var c = drawer.querySelector('.mobile-menu--close-btn'); if (c) c.click();
    }
  });
  drawer.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && stack.length) { e.stopPropagation(); back(); }
  }, true);
  new MutationObserver(function () { if (drawer.hasAttribute('inert')) reset(); }).observe(drawer, { attributes: true, attributeFilter: ['inert'] });

  build();
  window.svMobileMenu = { rebuild: build, reset: reset };
})();
